import React from 'react';

import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';
import {SERVICE_ICONS_TABLE} from '../components/constants';

const ServicesSection = (props) => {
  const commonServices = Object.entries(translate('caregiverProfile.Services.CommonServices'));
  const actualServices = [...commonServices];

  return (
    <Stack alignItems="flex-start" width="100%" spacing={0.5} sx={{}}>
      <Typography variant="h5" fontWeight="bold">
        <Translate expression='caregiverProfile.Services.Title'/>
      </Typography>
      <Typography variant="subtitle1" sx={{color: 'grey.700', pb: 1}}>
        <Translate expression='caregiverProfile.Services.Subtitle'/>
      </Typography>
      {/* Services */}
      <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'}, gap: 2, width: '100%'}}>
        {
          actualServices.map(([serviceKey, titleAndDescription]) => {
            const Icons = SERVICE_ICONS_TABLE[serviceKey];
            return (
              <Stack
                key={serviceKey}
                direction="row"
                alignItems="flex-start"
                spacing={2}
                sx={{
                  'p': 2,
                  'borderRadius': 4,
                  'bgcolor': 'white',
                  'width': '100%',
                  'boxSizing': 'border-box',
                  'border': '1px solid',
                  'borderColor': 'grey.300',
                  'transition': 'all 0.3s ease',
                  '&:hover': {
                    'boxShadow': 4, // elevates the card
                    'borderColor': 'primary.main',
                    '& .service-title': {
                      color: 'primary.main', // title turns blue
                    },
                    '& .service-icon': {
                      'bgcolor': 'primary.light',
                      '& svg': {
                        color: 'primary.main', // icon becomes blue
                      },
                    },
                  },
                }}
              >
                {/* Icon */}
                {Icons && (
                  <Box
                    className="service-icon"
                    sx={{
                      bgcolor: '#F5F6FF',
                      borderRadius: 2,
                      p: 1,
                      display: 'flex',
                      alignItems: 'center',
                      mr: 2,
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <Icons
                      sx={{
                        color: '#6C63FF',
                        fontSize: {xs: 20, sm: 24, md: 28, lg: 32},
                        transition: 'color 0.3s ease',
                      }}
                    />
                  </Box>
                )}
                {/* Service Title & Description */}
                <Stack spacing={1}>
                  <Typography
                    className="service-title"
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{transition: 'color 0.3s ease'}}
                  >
                    {titleAndDescription.Title}
                  </Typography>
                  <Typography variant="body2" color="grey.700">
                    {titleAndDescription.Description}
                  </Typography>
                </Stack>
              </Stack>
            );
          })
        }
      </Box>
    </Stack>
  );
};

ServicesSection.propTypes = {
  questions: PropTypes.object.isRequired,
};

export default ServicesSection;
